import supabaseClient from '../supabase/supabase';

// Exported Utility to prevent promises from hanging infinitely
export const withTimeout = (promise, ms) => {
  let timeoutId;
  const timeoutPromise = new Promise((_, reject) => {
    timeoutId = setTimeout(() => reject(new Error('Connection timeout')), ms);
  });
  return Promise.race([promise, timeoutPromise]).finally(() => {
    clearTimeout(timeoutId);
  });
};

export const checkSupabaseConnection = async () => {
  try {
    // Try a simple health check query with a strict 5-second timeout
    const { error } = await withTimeout(
      supabaseClient.from('profiles').select('id').limit(1),
      5000
    );
    if (error) {
      if (
        error.code === 'PGRST116' || 
        error.code === '42P01' || 
        error.message?.includes('not found') || 
        error.message?.includes('does not exist')
      ) {
        return { connected: true, message: 'Connected (Run Migrations)' };
      }
      throw error;
    }
    return { connected: true, message: 'System Online' };
  } catch (error) {
    console.error('Connection check failed:', error);
    // Fallback check: if the database query fails entirely, see if Auth is reachable
    try {
      const { error: authError } = await withTimeout(
        supabaseClient.auth.getSession(),
        3000
      );
      if (!authError) {
        return { connected: true, message: 'Connected (Auth Only)' };
      }
    } catch (fallbackError) {
      // Ignore fallback error
    }
    return { connected: false, message: error.message };
  }
};

export default supabaseClient;